import PropTypes from "prop-types";
import React, { useState } from "react";
import { map, isPlainObject, isArray, each, set, isEmpty, get } from "lodash";
import { v4 as uuidv4 } from "uuid";

import ControlGroup from "components/shared/fields/ControlGroup";
import Hint from "components/shared/fields/Hint";
import PropertyEdit from "components/appCreator/properties/PropertyEdit";
import { isPropRequired } from "components/appCreator/properties/helpers";
import Headline from "components/appCreator/properties/show/Headline";

function Fields({ properties, fieldErrors, appId, item }) {
  const [fieldIdBase] = useState(appId || uuidv4());

  const errors = {};
  each(fieldErrors, (error, key) => {
    set(errors, key, error);
  });

  return map(properties, (prop, i) => {
    const fieldId = `${fieldIdBase}-${prop.name}`;
    const name = get(prop, "name");
    const propErrors = get(errors, [name, prop.name]) || get(errors, prop.name);
    const propHasErrors = !isEmpty(propErrors);

    if (prop.type === "statistics") return null;
    if (prop.type === "headline")
      return (
        <>
          <Headline key={i} property={prop} />
          <Hint hint={prop.hint} />
        </>
      );

    return (
      <ControlGroup
        key={i}
        name={prop.name}
        label={prop.label}
        required={isPropRequired(prop)}
        htmlFor={fieldId}
        className={`${prop.type}-property`}
        error={propHasErrors}
      >
        <PropertyEdit
          property={prop}
          appId={appId} // deprecated
          id={fieldId}
          error={propHasErrors}
          item={item}
        />
        <Hint hint={prop.hint} />
        {map(
          isPlainObject(propErrors) || isArray(propErrors)
            ? propErrors
            : [propErrors],
          (error, i) => (
            <span key={i} className="help-block text-danger">
              {error}
            </span>
          ),
        )}
      </ControlGroup>
    );
  });
}

Fields.propTypes = {
  properties: PropTypes.array,
  fieldErrors: PropTypes.object,
  name: PropTypes.string,
  appId: PropTypes.string,
  options: PropTypes.object,
};

export default Fields;
